export default __webpack_public_path__ + "static/media/03.4e6b88db.jpg";